'use strict';

import Component from 'generic.basecomponent';
import flatpickr from "flatpickr";
import moment from 'moment';
import baseDatePickerConfig from 'base-datepicker-config';
import createEvent from 'create-event';
import $ from 'jquery';

export default class RangePicker extends Component {
    constructor(el) {
        super(el);
        this.init();
        this.$container = $(this.container);

        this.wrapper = null;
        let $wrapper = this.$container.parent('.js-rangepicker-wrapper');
        if ($wrapper.length) {
            this.wrapper = $wrapper[0];
        }
    }

    init() {
        this.currentValue = this.container.value;
        let rangePickerElement = this.container.cloneNode(false);
        rangePickerElement.classList.add('flatpickr');
        this.container.parentNode.insertBefore(rangePickerElement, this.container);
        let calendar = new flatpickr(rangePickerElement, Object.assign({}, baseDatePickerConfig, {
            dateFormat: 'j M y',
            mode: "range",
            disableMobile: true,
            clickOpens: false,
            onClose: (value) => {
                let newValue = this.serializeValue(value);
                if (newValue !== this.currentValue) {
                    this.currentValue = newValue;
                    this.change(newValue);
                }
                if (this.wrapper) {
                    this.wrapper.classList.remove('is-opened');
                }
            },
            onOpen: () => {
                if (this.wrapper) {
                    this.wrapper.classList.add('is-opened');
                }
            }
        }));
        rangePickerElement.addEventListener("change", (e) => {
            e.stopPropagation();
        });
        rangePickerElement.addEventListener('click', (e) => {
            calendar.toggle();
        });
        this.container.setAttribute('type', 'hidden');

    }

    change(newValue) {
        this.container.value = newValue;
        this.container.dispatchEvent(createEvent("change"));
        this.container.dispatchEvent(createEvent("input"));
    }

    serializeValue(dates) {
        if (dates.length === 2) {
            return dates.map(item => moment(item).format('YYYY-MM-DD')).join('|');
        } else {
            return '';
        }
    }
}


RangePicker.id = 0;



// WEBPACK FOOTER //
// ./app/components/rangepicker/js/generic.rangepicker.js